<ion-content class="container">
  <ion-row class="p-0  headerBreadcrumb">
    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
      <div class="d-flex headerBreadcrumb">
        <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickSetup('Setup')">
        <label class="font_semibold fs-16 ml-10 mt-5 black_color">
          <span class="cp" (click)="onClickSetup('Setup')">Increment / Setup</span> / <span
            [style.color]="buttonColorName">Email Content</span></label>
      </div>
    </ion-col>
  </ion-row>

  <div class="modal-body p-20">
    <ion-row> 
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <div class="input-form">
          <div>
            <p>Subject:</p> 
          </div>
        <div class="w-100" *ngIf="!isEditEmail">
          <mat-form-field class="w-100 mat-height40 pl-15 mat-input-style">
            <input matInput readonly [(ngModel)]="emailContentSubjectData" placeholder="Type here">
          </mat-form-field>       
        </div>
        <div class="w-100" *ngIf="isEditEmail">
          <mat-form-field class="w-100 mat-height40 pl-15 mat-input-style">
            <input matInput [(ngModel)]="emailContentSubject" placeholder="Type here">
          </mat-form-field>       
        </div>
        </div>
      </ion-col>
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <div class="btn-Group">
          <button *ngIf="!isEditEmail" (click)="onClickEdit()" [disabled]="isDisabledIncrementLetter"
          [ngClass]="{ 'disable': isDisabledIncrementLetter }">Edit</button>
          <button *ngIf="isEditEmail" (click)="onClickSaveBtn()">Save</button>
          <button class="mr-20" *ngIf="isEditEmail" (click)="isDiscardChanges()">Discard Changes</button>
        </div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="cardBox">
          <div class="email-content" *ngIf="!isEditEmail">
            <div [innerHTML]="emailContentBodyData"></div>
          </div>
          <div *ngIf="isEditEmail">
            <div>
              <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="emailContentBody" ></angular-editor>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
  </ion-content>



  <!-- <h5>
    Dear #Employee Name,
  </h5>
  <p>
    We are pleased to inform you that, as a result of an appraisal of your performance,
    your remuneration has been modified W.E.F April 1, 2022, and the new salary structure is as follows:
  </p>
  <p>
    Previous Salary: Rs. 53000/-
  </p>
  <p>
    Increment: Rs. 7000/-
  </p>
  <p>
    New Salary: Rs. 60000/-
  </p>
  <p>
    Please contact the HR department for the remainder of the week breakdown and other terms and 
    conditions. We look forward to your valuable contributions to the company and wish you success 
    in your future efforts.
  </p>
  <p>
    As a show of acceptance, please sign the duplicate copy of this letter.
  </p>
  <h5>
    Yours truly,
  </h5>
  <h5>
    Signature
  </h5>
  <h5>
    Kevin Durant
  </h5>
  <h5>
    HR Manager
  </h5> -->

   